import React from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';

const dummyRegulatoryInfo = {
  approvalStatus: 'Approved',
  storageConditions: 'Store below 25°C',
  shelfLifeMonths: 36,
};

const RegulatoryInfoCard = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Regulatory Information</CardTitle>
        <div className="table-responsive">
          <Table className="table-nowrap mb-0">
            <tbody>
              <tr>
                <th scope="row">Approval Status:</th>
                <td>{dummyRegulatoryInfo.approvalStatus}</td>
              </tr>
              <tr>
                <th scope="row">Storage Conditions:</th>
                <td>{dummyRegulatoryInfo.storageConditions || 'N/A'}</td>
              </tr>
              <tr>
                <th scope="row">Shelf Life:</th>
                <td>
                  {dummyRegulatoryInfo.shelfLifeMonths
                    ? `${dummyRegulatoryInfo.shelfLifeMonths} months`
                    : 'N/A'}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default RegulatoryInfoCard;
